import Row from '../Row';

export default [
	{
		component: Row,
		props: {
			id: 'cz_hranice',
			type: 'overlay',
			category: 'layer',
			className: 'js-layer',
			value: 'cz_hranice',
			name: 'Hranica SR',
			initial: false,
			icon: false,
		}
	},
	{
		component: Row,
		props: {
			id: 'cz_kraje',
			type: 'overlay',
			category: 'layer',
			className: 'js-layer',
			value: 'cz_kraje',
			name: 'Kraje',
			initial: false,
			icon: false,
		}
	},
	{
		component: Row,
		props: {
			id: 'cz_okresy',
			type: 'overlay',
			category: 'layer',
			className: 'js-layer',
			value: 'cz_okresy',
			name: 'Okresy',
			initial: false,
			icon: false,
		}
	}
];
